import moment, { Moment } from 'moment'

import { IntervalUnit, MasterCampaignPlanCampaignBuilder } from 'api/entities/MasterCampaignStub'

export function getIntervalUnitLabel(intervalUnit: IntervalUnit | undefined, count: number): string {
  if (!intervalUnit) {
    return ''
  }

  const base = intervalUnit.toLowerCase()

  return count === 1 ? base : `${base}s`
}

export function calculateEndDate(builder: MasterCampaignPlanCampaignBuilder): Moment {
  const { startDate, intervalUnit, intervalFrequency, intervalDuration } = builder

  if (!intervalUnit || !intervalFrequency || !intervalDuration) {
    return moment(startDate)
  }

  const unit = intervalUnit.toLowerCase() as moment.unitOfTime.DurationConstructor

  return moment(startDate).add(intervalDuration * intervalFrequency, unit)
}
